import {Component} from "@angular/core";

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    styleUrls: ['./notfound.component.scss'],
})
export class NotfoundComponent {
    showContent = false;

    goHome(): void {
        window.location.href = $localize`https://wrench.com`;
    }

}
